import { Select, SelectProps, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { SkodaSelectMenuPaperProps } from '../scrollbars/scrollbars';
import { MobileSelect } from './mobileSelect';

export type ResponsiveSelectProps = Omit<SelectProps, 'ref'> & {
    textCancel: string;
    textConfirm: string;
    dark?: boolean;
	menuHeader?: React.ReactNode;
};

export const ResponsiveSelect = React.forwardRef<HTMLDivElement, ResponsiveSelectProps>((props, ref) => {
    const { textCancel, textConfirm, dark, menuHeader, ...other } = props;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.originalBreakpoints.up('sm'));
	
	const MenuProps = {
		...theme.components.MuiSelect.defaultProps.MenuProps,
		PaperProps: {
			...theme.components.MuiSelect.defaultProps.MenuProps.PaperProps,
			menuHeader
		} as SkodaSelectMenuPaperProps
	};

    return isDesktop
        ? <Select data-test='select-desktop' MenuProps={MenuProps} {...other} ref={ref} />
        : <MobileSelect data-test='select-mobile' {...props} ref={ref}/>;
}); 
